import { request } from 'service/api/common';
import * as apiUrl from './apiUrl';

//shp
export const getShp = async (siteId) => {
  const { data } = await request('d2').get(apiUrl.shp.list(siteId));
  return data.data;
};
